import './styles.scss';
import { memo } from 'react';
import Fan from '../../../assets/load.png';

interface FreezeLoaderProps {
  primary?: boolean;
  backgroundColor?: string;
}

/**
 * Primary UI component for user interaction
 */
export function FreezeLoader({ primary, backgroundColor }: FreezeLoaderProps) {
  return (
    <div className="loader" style={{ backgroundColor }}>
      <div
        className={[
          'spinner',
          `spinner-${primary ? 'active' : 'deactive'}`,
        ].join(' ')}
      >
        <img src={Fan} alt="fan" />
      </div>
    </div>
  );
}

FreezeLoader.defaultProps = {
  primary: true,
  backgroundColor: '#00000080',
};

export default memo(FreezeLoader);
